import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["accessibilityLabel", "id", "size", "testID", "UNSAFE_svgProps"];
import React from 'react';
import Surface from '@bubble-ui/primitive-surface';
import Shape from '@bubble-ui/primitive-shape';
import withProvisionalOverrideFromContext from '@bubble-ui/hoc-with-provisional-override-from-context';
import { usePropsSpreadingDeprecationWarning } from '@bubble-ui/hook-use-props-spreading-deprecation-warning';
var SpotOfficeEquipmentComponent = _ref => {
  var {
      accessibilityLabel,
      id,
      size = 24,
      testID,
      UNSAFE_svgProps
      /**
       * @deprecated props spreading is outdated and will be removed with v7.0.0
       */
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  usePropsSpreadingDeprecationWarning({
    componentName: 'SpotOfficeEquipment',
    props,
    useInstead: 'UNSAFE_svgProps',
    removalDate: 'v7.0.0'
  });
  return /*#__PURE__*/React.createElement(Surface, _extends({
    id: id
  }, testID ? {
    testID
  } : {}, UNSAFE_svgProps, {
    accessibilityLabel: accessibilityLabel,
    fill: "none",
    viewBox: "0 0 24 24",
    width: size,
    height: size
  }, props), /*#__PURE__*/React.createElement(Shape, {
    fill: "#6CC6FF",
    d: "M15.136 7.69c.147-.108.283.048.42.116 1.503.762 3.016 1.533 4.519 2.294.146-.127.293-.254.44-.371 0 0-1.035-.625-1.572-.898-1.777-.917-5.934-2.967-5.944-2.977-.898-.43-1.933-.82-3.016-.82a5.984 5.984 0 1 0 5.983 5.983 5.963 5.963 0 0 0-.898-3.142.19.19 0 0 1 .068-.186Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#0076BE",
    d: "M10.032 14a2.968 2.968 0 1 0 0-5.936 2.968 2.968 0 0 0 0 5.936ZM2 17h18v1a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1v-1Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#0094EE",
    d: "M20.035 10.24a.992.992 0 0 1 1.893.591L20 17H2.027v-4a2 2 0 0 1 2-2h7.026c1.104 0 1.812.865 2 2l.021.066c.263 1.394 1.64 2.416 3.109 2.416 1.48 0 2.595-1.115 2.981-2.482h.008l.863-2.76Z"
  }));
};
SpotOfficeEquipmentComponent.displayName = 'SpotOfficeEquipment';
export var SpotOfficeEquipment = withProvisionalOverrideFromContext(SpotOfficeEquipmentComponent);
//# sourceMappingURL=index.js.map